import { useTriggerZendeskWidget } from "@modules/zendesk"
import { Link, Notification, Text, ThemeCss } from "gatsby-interface"
import { errorAlert as errorAlertText } from "@modules/locales/default.js"
import * as React from "react"

export type LogDrainIntegrationErrorProps = {
  children?: React.ReactNode
  className?: string
}

export function LogDrainIntegrationError({
  children,
  className,
}: LogDrainIntegrationErrorProps) {
  const triggerZendeskWidget = useTriggerZendeskWidget()

  return (
    <Notification
      content={
        <div>
          <Text css={supportTextCss}>
            {children}
            {` `} Need Help? {` `}
            <Link
              onClick={() => {
                triggerZendeskWidget()
              }}
              css={contactButton}
            >
              {errorAlertText.actions.contactSupport}
            </Link>
          </Text>
        </div>
      }
      variant="SECONDARY"
      tone="DANGER"
      role="alert"
      className={className}
      css={baseCss}
    />
  )
}

/* Styles */
const baseCss: ThemeCss = theme => ({
  boxShadow: `0 0 0 1px ${theme.tones.DANGER.light} inset`,
  marginBottom: theme.space[5],
  flex: ``,
})

const supportTextCss: ThemeCss = _theme => ({
  color: `inherit`,
  fontSize: `inherit`,
  margin: 0,
})

const contactButton: ThemeCss = theme => ({
  textDecoration: `none`,
})
